import {
    ConditionType,
    ConditionType_DateFixedAfter,
    ConditionType_DateFixedBefore,
    ConditionType_DateFixedEquals, ConditionType_DateFixedRange,
    ConditionType_DateRelativeAfter,
    ConditionType_DateRelativeBefore,
    ConditionType_DateRelativeEquals,
    ConditionType_DateRelativePeriod,
    ConditionType_DateRelativeRange, ConditionType_IsNull, ConditionType_NotNull,
} from "../../model2/conditions/condition-types"
import Filter from "../../manager/filters/manager/filter"
import DatetimeUtils from "../../gd/utils/datetime-utils"
import {DateRangeRelativity} from "../generic/datetime/date-range-relative-period/date-range-relative-period"


// !!! move const to @const

export const FIELD_CONDITIONS_DATE_IS_SET = [
    ConditionType_IsNull,
    ConditionType_NotNull,
]

export const FIELD_CONDITIONS_DATE_RELATIVE = [
    ConditionType_DateRelativeBefore,
    ConditionType_DateRelativeAfter,
    ConditionType_DateRelativeEquals,
    ConditionType_DateRelativeRange,
    ConditionType_DateRelativePeriod,
]

export const FIELD_CONDITIONS_DATE_FIXED = [
    ConditionType_DateFixedBefore,
    ConditionType_DateFixedAfter,
    ConditionType_DateFixedEquals,
    ConditionType_DateFixedRange,
]

export const FIELD_CONDITIONS_DATE = [
    ...FIELD_CONDITIONS_DATE_RELATIVE,
    ...FIELD_CONDITIONS_DATE_FIXED,
]

export const FIELD_CONDITIONS_DATE_WITH_NULL = [
    ...FIELD_CONDITIONS_DATE_IS_SET,
    ...FIELD_CONDITIONS_DATE_RELATIVE,
    ...FIELD_CONDITIONS_DATE_FIXED,
]

export function FieldDate_filterFunc(filter: Filter, model:any): boolean {
    if (!filter.type) return true;  // Esli net condition type propuskaem filter

    let fieldValue: string | null = _.get(model, filter.field?.fieldId!,null)

    const filterValue = filter.value
    const filterStartValue = filterValue?.start
    const filterEndValue = filterValue?.end

    let filterValueMoment: Moment = moment()
    let filterStartValueMoment: Moment = moment()
    let filterEndValueMoment: Moment = moment()

    if (typeof filterValue === 'number' || typeof filterStartValue === 'number' || typeof filterEndValue === 'number') {
        filterValueMoment = moment().add(filterValue, 'days')
        filterStartValueMoment = moment().add(filterValue.start, 'days')
        filterEndValueMoment = moment().add(filterValue.end, 'days')
    } else {
        filterValueMoment = DatetimeUtils.dateToMoment(filterValue)
        filterStartValueMoment = DatetimeUtils.dateToMoment(filterValue?.start)
        filterEndValueMoment = DatetimeUtils.dateToMoment(filterValue?.end)
    }

    // Field value
    switch (filter.type) {
        case ConditionType.IS_NULL:
            return _.isNil(fieldValue)
        case ConditionType.NOT_NULL:
            return !_.isNil(fieldValue)
    }

    if (!fieldValue) return false
    const fieldValueMoment: Moment = DatetimeUtils.dateToMoment(fieldValue)

    switch (filter.type) {
        case ConditionType.DATE_RELATIVE_PERIOD:
            let relativeValue: any
            switch (filterValue.relativity) {
                case DateRangeRelativity.THIS:
                    relativeValue = {
                        start   : moment().startOf(filterValue.period),
                        end     : moment().endOf(filterValue.period)
                    }
                    break

                case DateRangeRelativity.LAST:
                    relativeValue = {
                        start   : moment().subtract(1, filterValue.period).startOf(filterValue.period),
                        end     : moment().subtract(1, filterValue.period).endOf(filterValue.period)
                    }
                    break
            }

            return fieldValueMoment.isSameOrAfter(relativeValue.start, 'day') && fieldValueMoment.isSameOrBefore(relativeValue.end, 'day')

        case ConditionType.DATE_RELATIVE_BEFORE:
        case ConditionType.DATE_FIXED_BEFORE:
            return fieldValueMoment.isBefore(filterValueMoment, 'day')
        case ConditionType.DATE_RELATIVE_AFTER:
        case ConditionType.DATE_FIXED_AFTER:
            return fieldValueMoment.isAfter(filterValueMoment, 'day')
        case ConditionType.DATE_RELATIVE_EQUALS:
        case ConditionType.DATE_FIXED_EQUALS:
            return fieldValueMoment.isSame(filterValueMoment, 'day')
        case ConditionType.DATE_RELATIVE_RANGE:
        case ConditionType.DATE_FIXED_RANGE:
            return fieldValueMoment.isSameOrAfter(filterStartValueMoment, 'day') && fieldValueMoment.isSameOrBefore(filterEndValueMoment, 'day')
        default:
            return false
    }
}